import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'

interface Provet {
  getAppVersion: () => string
}

declare global {
  interface Window {
    provet: Provet
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  nuxtApp.hook('app:mounted', () => {
    window.provet = {
      getAppVersion: () => config.public.appVersion,
    }
  })
})
